import { Button, Input, message, Modal, Select } from 'antd';
import Link from 'antd/es/typography/Link';
import React, { useRef, useState } from 'react';
import { postRequest } from '../../helpers/apiCall';
import { useSearchParams } from 'react-router-dom';

export default function CustomSelect({ ...props }) {
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const selectRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notSureHelpButton, setNotSureHelpButton] = useState(false);
  const [notSureHelpMsg, setNotSureHelpMsg] = useState('');
  const [notSureHelpLoading, setNotSureHelpLoading] = useState(false);
  const [notSureHelpResp, setNotSureHelpResp] = useState('');
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  async function askAi() {
    try {
      if (!notSureHelpMsg) {
        message.error('Please enter a message');
        return;
      }
      setNotSureHelpLoading(true);
      const resp = await postRequest('business-under-catagory-with-ai', {
        message: notSureHelpMsg,
      });
      if (resp?.data?.success) {
        setNotSureHelpResp(resp?.data);
        setNotSureHelpButton(false);
        setNotSureHelpLoading(false);
      }
      setNotSureHelpLoading(false);
    } catch (error) {
      message.error(error.message);
    }
  }
  return (
    <>
      <Select
        ref={selectRef}
        placeholder="Select an option"
        open={isSelectOpen}
        onFocus={e => {
          setIsSelectOpen(true);
        }}
        onBlur={e => {
          setIsSelectOpen(false);
        }}
        onSelect={e => {
          setIsSelectOpen(false);
          selectRef.current.blur();
        }}
        notFoundContent={
          <>
            {type == 'experience' ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <span>Could not find what you are looking for</span>

                <Link onClick={() => setIsModalOpen(true)}>Ask AI</Link>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <span>No data</span>
              </div>
            )}
          </>
        }
        {...props}
        style={{ width: '100%', backgroundColor: '' }}
      />
      {type == 'experience' &&  <Link onClick={() => setIsModalOpen(true)}>Not sure? Help me decide</Link>}

      {type == 'experience' && (
        <Modal
          title="Ask AI "
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={isModalOpen}
          footer={false}
          onCancel={() => {
            setNotSureHelpButton(false);
            setNotSureHelpLoading(false);
            setNotSureHelpMsg('');
            setIsModalOpen(false);
          }}
        >
          <Input.TextArea
            rows={4}
            placeholder="Enter your message"
            value={notSureHelpMsg}
            onChange={e => setNotSureHelpMsg(e.target.value)}
            style={{ marginBottom: '10px' }}
          />
          <Button loading={notSureHelpLoading} type="primary" onClick={() => askAi()}>
            Send
          </Button>

          {notSureHelpResp && (
            <div
              className="mt20"
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255,255,255)',
                // cursor: 'pointer',
              }}
            >
              <span className="">
                {!(notSureHelpResp?.result?.category == 'unknown') ? (
                  <>
                    {' '}
                    It looks like your business best fits in the{' '}
                    <strong
                      onClick={() => {
                        if (notSureHelpResp?.result?.category_id) {
                          // console.log(notSureHelpResp);
                          props.onChange(notSureHelpResp?.result?.category_id);
                          setIsModalOpen(false);
                        }
                      }}
                      style={{ color: '#1c64f2', cursor: 'pointer' }}
                    >
                      {notSureHelpResp?.result?.category}
                    </strong>{' '}
                    <span>category with sub-category </span>
                    <strong
                      onClick={() => {
                        if (notSureHelpResp?.result?.category_id) {
                          // console.log(notSureHelpResp);
                          props.onChange(notSureHelpResp?.result?.category_id);
                          setIsModalOpen(false);
                        }
                      }}
                      style={{ color: '#1c64f2', cursor: 'pointer' }}
                    >
                      {' '}
                      {notSureHelpResp?.result?.subcategory}
                    </strong>
                    . Click the category to continue.{' '}
                  </>
                ) : (
                  <>
                    Sorry we could not find a category that best fits your business activity. Please
                    write a short description of your business activity so we can recommend the
                    best-fit category.
                  </>
                )}
              </span>
            </div>
          )}
        </Modal>
      )}
    </>
  );
}
